import "./SuperAdminAllTransferOutRequest.css";

import React, { useEffect, useState } from "react";

import AcceptTransferOutRequest from "Components/Popup/AcceptTransferOutRequest/AcceptTransferOutRequest";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import Headers from "Components/Header/Headers";
import Navigation from "Components/SideNavBar/Navigation";
import { getAllTransferOutRequests } from "Config/API/get";
import { modifyTransferOutRequest } from "Config/API/action";
import { toast } from "react-toastify";
import useFullPageLoader from "Hooks/useFullPageLoader";
import { raiseTransferRequestIdAction } from "Redux/action/variable.action";

import detailsIcon from "Media/icons/Group 641@2x.png";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

const SuperAdminAllTransferOutRequest = () => {
  let doneTypingInterval = 1500;
  let typingTimer;
  const token = localStorage.getItem("token");
  const [loader, setLoader, resetLoader] = useFullPageLoader();
  const [requestList, setRequestList] = useState([]);
  const [searchedText, setSearchedText] = useState("");
  const [filterType, setFilterType] = useState("");
  const [loading, setLoading] = useState(false);
  const [showAcceptRequestPopup, setShowAcceptRequestPopup] = useState(false);
  const [selectedData, setSelectedData] = useState([]);
  const statusColor = {
    pending: "#E8B81A",
    approved: "#5CA127",
    rejected: "#CB1212",
  };

  useEffect(() => {
    setLoader();
    getData(filterType, searchedText);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getData = (filter, searchKeywords) => {
    const requestResponse = getAllTransferOutRequests(
      token,
      searchKeywords,
      filter
    );
    requestResponse.then((res) => {
      resetLoader();
      if (res?.status === 200) {
        setRequestList(res?.data?.data);
      }
    });
  };

  const searchData = (value) => {
    setSearchedText(value);
    getData(filterType, value);
  };

  const filterData = (value) => {
    if (value === "all") {
      setFilterType("");
      getData("", searchedText);
      return;
    } else {
      setFilterType(value);
      getData(value, searchedText);
    }
  };

  const changeStatus = (status, data, trn, setAcceptLoading) => {
    if (loading) return;
    setLoading(true);
    if (status === "approve") {
      const statusChange = modifyTransferOutRequest(
        token,
        data?.id,
        "approved",
        trn
      );
      statusChange.then((res) => {
        setLoading(false);
        setAcceptLoading(false);
        if (res?.status) {
          setShowAcceptRequestPopup(false);
          getData("", "");
          toast(res?.message, {
            type: "success",
          });
        } else {
          toast(res?.message, {
            type: "error",
          });
        }
      });
    } else if (status === "reject") {
      const statusChange = modifyTransferOutRequest(
        token,
        data?.id,
        "rejected",
        ""
      );
      statusChange.then((res) => {
        setLoading(false);
        if (res?.status) {
          getData("", "");
          toast(res?.message, {
            type: "success",
          });
        } else {
          toast(res?.message, {
            type: "error",
          });
        }
      });
    }
  };
  const navigate = useNavigate();
  const dispatch = useDispatch();
  return (
    <>
      <div className="all-super-admin-transfer-out-request-parent">
        <div className="all-super-admin-transfer-out-request-header">
          <Headers />
        </div>

        <div className="all-super-admin-transfer-out-request-navigation">
          <Navigation />
        </div>

        <div className="all-super-admin-transfer-out-request-main">
          <div className="all-super-admin-transfer-out-request-wrapper">
            <div className="all-super-admin-transfer-out-request-heading">
              All Transfer Out Request
            </div>
            <div className="all-super-admin-transfer-out-request-all-active">
              <div className="all-super-admin-transfer-out-request-top">
                <input
                  type="search"
                  placeholder="Search"
                  onChange={(e) => {
                    clearTimeout(typingTimer);
                    if (e.target.value || e.target.value === "") {
                      typingTimer = setTimeout(() => {
                        searchData(e.target.value);
                      }, doneTypingInterval);
                    }
                  }}
                />
                <div>
                  <p>Filter:</p>
                  <select
                    onClick={(e) => {
                      filterData(e.target.value);
                    }}
                  >
                    <option value="all">All</option>
                    <option value="pending">PENDING</option>
                    <option value="approved">APPROVED</option>
                    <option value="rejected">REJECTED</option>
                  </select>
                </div>
              </div>
              <div className="all-super-admin-transfer-out-request-row-wrapper">
                <div className="all-super-admin-transfer-out-request-head-row">
                  DATE
                </div>
                <div className="all-super-admin-transfer-out-request-head-row">
                  REQUESTER
                </div>
                <div
                  className="all-super-admin-transfer-out-request-head-row"
                  style={{ width: "20%" }}
                >
                  EMAIL
                </div>
                <div className="all-super-admin-transfer-out-request-head-row">
                  ORGANIZATION
                </div>
                <div
                  className="all-super-admin-transfer-out-request-head-row"
                  style={{ width: "25%" }}
                >
                  COMMENT
                </div>
                <div className="all-super-admin-transfer-out-request-head-row">
                  CREDITS
                </div>
                <div className="all-super-admin-transfer-out-request-head-row">
                  ACTION
                </div>
              </div>
              <div className="all-super-admin-transfer-out-request-bottom">
                {requestList?.length?.toString() !== "0" ? (
                  requestList?.map((curr, index) => {
                    return (
                      <div
                        className="all-super-admin-transfer-out-request-content-wrapper"
                        key={index}
                      >
                        <div className="all-super-admin-transfer-out-request-content-row">
                          {curr?.dateTime}
                        </div>
                        <div className="all-super-admin-transfer-out-request-content-row">
                          {curr?.userName}
                        </div>
                        <div
                          className="all-super-admin-transfer-out-request-content-row"
                          style={{ width: "20%" }}
                        >
                          {curr?.email}
                        </div>
                        <div className="all-super-admin-transfer-out-request-content-row">
                          {curr?.organization_name}
                        </div>
                        <div
                          className="all-super-admin-transfer-out-request-content-row"
                          style={{ width: "25%" }}
                        >
                          {curr?.comment}
                        </div>
                        <div
                          className="all-super-admin-transfer-out-request-content-row"
                          style={{ color: "#5CA127", fontWeight: "bold" }}
                        >
                          {curr?.credit}
                        </div>
                      <div 
  className="all-super-admin-transfer-out-request-content-row" 
  style={{ display: "flex", alignItems: "center" }}
>
  <div 
    style={{ 
      width: "110px", 
      display: "flex", 
      alignItems: "center", 
      justifyContent: "space-between" 
    }}
  >
    
    {/* Status Actions / Labels */}
    <div style={{ minWidth: "80px", display: "flex", alignItems: "center" }}>
                          {curr?.status?.toString() === "pending" && (
                            <div className="all-refund-status-button-container">
                              <CheckIcon
                                className="all-refund-status-button"
                                fontSize="small"
                                style={{ backgroundColor: "#5CA127" }}
                                onClick={() => {
                                  setSelectedData(curr);
                                  setShowAcceptRequestPopup(true);
                                }}
                              />
                              <CloseIcon
                                className="all-refund-status-button"
                                fontSize="small"
                                style={{ backgroundColor: "#D81C1C" }}
                                onClick={() => changeStatus("reject", curr)}
                              />
                            </div>
                          )}

      {curr?.status?.toString() !== "pending" && (
        <label style={{ backgroundColor: statusColor[curr?.status], padding: "2px 6px", borderRadius: "4px" }}>
                              {curr?.status}
                            </label>
                          )}
    </div>

    {/* Info Icon */}
    <svg
      onClick={() => {
        dispatch(raiseTransferRequestIdAction(curr?.id));
        navigate("/transfer-out-request-info");
      }}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      fill="none"
      stroke="#fff"
      strokeWidth="3.5"
      strokeLinecap="round"
      strokeLinejoin="round"
                              style={{
        cursor: "pointer",
        width: "22px",
        height: "22px",
        borderRadius: "50%",
        backgroundColor: "#446fa2",
        flexShrink: 0
                              }}
                            >
      <line x1="16" y1="22" x2="16" y2="12" />
      <circle cx="16" cy="8" r="2" fill="#fff" stroke="none" />
    </svg>

  </div>
                        </div>

                      </div>
                    );
                  })
                ) : (
                  <div className="all-super-admin-transfer-out-request-msg">
                    No Requests Found
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {showAcceptRequestPopup && (
        <AcceptTransferOutRequest
          hide={setShowAcceptRequestPopup}
          requestDetails={selectedData}
          changeStatus={changeStatus}
        />
      )}
      {loader}
    </>
  );
};

export default SuperAdminAllTransferOutRequest;
